export const dataHooks = {
  dsCategoriesInputArea: 'ds-categories-input-area',
  HeaderTitle: 'header-title',
  HeaderSubtitle: 'header-subtitle',
  CategorySelector: 'category-selector',
  categoryButton: (value: string) => `category-button-${value}`,
};
